<main id="main-content" aria-label="Course">
  @if (course) {
    <div class="content-contain mx-auto my-4">
      <prism-title additionalClasses="text-4xl text-center sm:text-left" [title]="course.name"></prism-title>
      <hr class="h-1 bg-dark-purple border-0 my-4">

      <prism-title additionalClasses="text-xl pt-3" title="Attachments" headingLevel="h2"></prism-title>
      <div class="grid grid-cols-1 lg:grid-cols-4 gap-4">
        @if (user.userId) {
          <div class="col-span-1 gap-1 flex flex-wrap flex-col md:flex-row pb-4">
            <prism-btn
              [disabled]="!hasCertificate"
              btnClass="btn-purple flex-full w-full text-nowrap"
              (click)="viewPrintCertificate()"
              [ariaLabel]="!hasCertificate
                ? 'Download Certificate, not yet available. Complete all modules to unlock your certificate.'
                : 'Download Certificate'">
              Download Certificate
              <i class="uil uil-import text-xl text-white" aria-hidden="true"></i>
            </prism-btn>
          </div>
        }
      </div>

      <prism-title additionalClasses="text-xl pt-3" title="Course Description" headingLevel="h2"></prism-title>
      <p>{{ course.description }}</p>

      <prism-btn btnClass="mt-4 btn-purple flex-full pt-2 text-nowrap" (click)="toggleStartCourse()">
        {{ btnText }}
      </prism-btn>

      <div class="mt-10 pt-4 border-t border-gray-200 flex justify-end">
        <button
          type="button"
          class="text-xs text-gray-500 hover:text-red-600 hover:underline focus:outline-none focus:underline"
          (click)="resetCourse()"
          aria-label="Reset course progress">
          <i class="uil uil-redo" aria-hidden="true"></i>
          Reset course progress
        </button>
      </div>
    </div>
  } @else {
    <div class="content-contain mx-auto my-4">
      <p>Course not found.</p>
    </div>
  }
</main>
